import { memo } from 'react'

const HeaderBar = memo(({ children }) => children)

HeaderBar.defaultProps = {
  type: 'HeaderBar'
}

export default HeaderBar
